import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { BlogArticleDetail } from 'src/app/services/rest-api/rest-api';
import { RestApiService } from 'src/app/services/rest-api/rest-api.service';

@Component({
  selector: 'libero-blog-article-preview-external',
  templateUrl: './blog-article-preview-external.component.html',
  styleUrls: ['./blog-article-preview-external.component.scss'],
  standalone: false
})
export class BlogArticlePreviewExternalComponent implements OnInit, OnDestroy {
  private articleSecret?: string;
  public articleDetail?: BlogArticleDetail;
  private detailSubscription?: Subscription;
  public errored = false;
  public loading = true;

  public constructor(
    private route: ActivatedRoute,
    private restApiService: RestApiService,
  ) {}

  public ngOnDestroy(): void {
    this.detailSubscription?.unsubscribe();
  }

  public ngOnInit(): void {
    this.detailSubscription = this.route.params.pipe(
      mergeMap((params: Params) => {
        this.articleSecret = params['articleSecret'];
        if (this.articleSecret) {
          return this.restApiService.getBlogArticlePreview(this.articleSecret)
        }
        return throwError(() => 'Missing article token in URL.');
      })
    )
    .subscribe({
      next: articleDetail => {
        this.loading = false;
        if (articleDetail) {
          this.articleDetail = articleDetail as BlogArticleDetail;
        }
      },
      error: () => { this.loading = false; this.errored = true; }
    });

  }

}
